module.exports = __webpack_public_path__ + "static/img/ipro_logo.99e460f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ipro_logo.png
// module id = 1eXb
// module chunks = 9